export default __webpack_public_path__ + "static/media/PAFI_LKTT 2020.8d0c3963.pdf";